function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { isServer } from '@sail/engine';
import { createRpc, fromIframe, fromInsideIframe } from '@sail/rpc';
import { mediaQueryManager } from '../../components/hooks/useMatchMedia/MediaQueryManager';
const subscriptions = {
    matchMedia ({ query }, callback) {
        callback({
            matches: mediaQueryManager.matchMedia(query).matches
        });
        const unsubscribe = mediaQueryManager.addQueryListener(query, ({ matches })=>{
            callback({
                matches
            });
        });
        return {
            unsubscribe
        };
    }
};
export const rpc = createRpc({
    namespace: '@sail/ui',
    subscriptions,
    methods: {}
});
class UiRpc {
    initServerFromIframe(iframe) {
        return rpc.initServer({
            transport: fromIframe(iframe)
        });
    }
    constructor(){
        _define_property(this, "client", void 0);
        this.client = rpc.initClient({
            transport: fromInsideIframe()
        });
        // Only initialize the rpc server if we are not inside an iframe.
        // If inside an iframe, the rpc server must be initialized from the parent window.
        const notInsideIframe = !window.parent || window.parent === window;
        if (notInsideIframe) {
            rpc.initServer({
                transport: fromInsideIframe()
            });
        }
    }
}
export const uiRpc = !isServer ? new UiRpc() : null;

//# sourceMappingURL=rpc.js.map